import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'medidas'
})
export class MedidasPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
